import React, { useEffect, useState } from "react";
import janusApi from "../../janus-api";
import { useDispatch, useSelector } from "react-redux";
import Header from "./ListRoomsHeader";
import { actionCreators as authActions } from "../../state/ducks/auth";
import "./ListRooms.css";

function ListRooms() {
  const dispatch = useDispatch();
  const [rooms, setRooms] = useState([]);
  const meetingData = useSelector((state) => state.auth.allMeetings);

  useEffect(() => {
    dispatch(authActions.getAllMeetings());
    // eslint-disable-next-line
  }, []);

  const getSortedData = (data) => {
    return data.sort(
      (a, b) =>
        a.AgencyName.localeCompare(b.AgencyName) ||
        new Date(b.CreationTimestamp).getTime() -
          new Date(a.CreationTimestamp).getTime()
    );
  };

  return (
    <div>
      <div className="px-4 py-1 text-white font-bold border-b-4 border-secondary bg-primary-dark ">
        <Header></Header>
      </div>
      <div className="flex items-center justify-center">
        <div className="container">
          <div className="px-8 pt-5">
            <h1 className="text-3xl font-bold text-gray-900 tracking-tight">
              Rooms
            </h1>
            <table className="w-full flex flex-row flex-no-wrap sm:bg-white rounded-lg overflow-hidden sm:shadow-lg my-5">
              <thead className="text-white">
                <tr className="bg-black flex flex-col flex-no wrap sm:table-row rounded-l-lg sm:rounded-none mb-2 sm:mb-0">
                  <th className="p-3 text-left">ID</th>
                  <th className="p-3 text-left">Agency Name</th>
                  <th className="p-3 text-left">Room Pin</th>
                  <th className="p-3 text-left">Admin Secret Required</th>
                  <th className="p-3 text-left">Created At</th>
                </tr>
              </thead>
              <tbody className="flex-1 sm:flex-none">
                {!meetingData?.isLoading &&
                  meetingData?.data?.length > 0 &&
                  getSortedData(meetingData.data).map((data) => {
                    return (
                      <tr className="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                        <td className="border-grey-light border hover:bg-gray-100 p-3">
                          {data.Name}
                        </td>
                        <td className="border-grey-light border hover:bg-gray-100 p-3 truncate">
                          {data.AgencyName}
                        </td>
                        <td className="border-grey-light border hover:bg-gray-100 p-3 truncate">
                          {data.RoomPin}
                        </td>
                        <td
                          className={`border-grey-light border hover:bg-gray-100 p-3 text-${
                            data.AdminSecretKey ? "green" : "red"
                          }-400 hover:text-${
                            data.AdminSecretKey ? "green" : "red"
                          }-600 hover:font-medium`}
                        >
                          {data.AdminSecretKey ? "True" : "False"}
                        </td>
                        <td className="border-grey-light border hover:bg-gray-100 p-3 truncate">
                          {new Date(data.CreationTimestamp).toDateString()}
                        </td>
                      </tr>
                    );
                  })}
                {!meetingData?.isLoading && !meetingData?.data && (
                  <tr className="flex flex-col flex-no wrap sm:table-row mb-2 sm:mb-0">
                    <td className="border-grey-light border hover:bg-gray-100 p-3">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ListRooms;
